import { RouteObject } from "react-router-dom";
import CheckInLayout from "src/layouts/CheckInLayout";
import QuestionsLayout from "src/layouts/QuestionsLayout";
import { Matches } from "../matches";
import Questions from "src/pages/Questions";
import CompleteRefillVisit from "src/pages/CompleteRefillVisit";
import PageTrackerProvider from "src/context/PageTrackerProvider";

export const refillRoutes: RouteObject[] = [
  {
    element: (
      <PageTrackerProvider>
        <CheckInLayout />
      </PageTrackerProvider>
    ),
    path: "refill",
    children: [
      {
        element: <QuestionsLayout />,
        children: [
          {
            path: Matches.QUESTION_ID,
            element: <Questions />,
          },
        ],
      },
      {
        path: "complete",
        element: <CompleteRefillVisit />,
      },
    ],
  },
];
